module.exports = __webpack_public_path__ + "img/bs.ad37543c.svg";